(function ($) {
	'use strict';

	if (typeof thirsty_cases_vars === 'undefined') {
		return;
	}

	var grid = $('.cases-grid');
	var showMoreWrap = $('.cases-show-more-wrap');
	var showMoreBtn = $('.cases-show-more-btn');
	var countEl = $('.cases-count');
	var searchInput = $('#brand-search');
	var filterBtn = $('#cases-filter-btn');
	var filterSidebar = $('#cases-filter-sidebar');
	var filterClose = $('#cases-filter-sidebar-close');
	var layout = $('#cases-page-layout');
	var applyBtn = $('#cases-filter-apply');
	var clearBtn = $('#cases-filter-clear-all');
	var industryCheckboxes = $('.cases-filter-industry');
	var directorCheckboxes = $('.cases-filter-director');
	var sortRadios = $('.cases-filter-sort');

	if (!grid.length || !layout.length) {
		return;
	}

	var perPage = thirsty_cases_vars.per_page || 21;
	var state = {
		filterOpen: false,
		pendingIndustries: [],
		pendingDirectors: [],
		appliedIndustries: [],
		appliedDirectors: [],
		sortType: 'featured',
		search: '',
		offset: perPage
	};
	var isLoading = false;

	function updateCount(shown, total) {
		countEl.text(shown + ' out of ' + total);
		countEl.attr('data-shown', shown);
		countEl.attr('data-total', total);
	}

	function setLoading(loading) {
		isLoading = loading;
		showMoreBtn.prop('disabled', loading);
	}

	function openSidebar() {
		state.filterOpen = true;
		layout.addClass('cases-filter-open');
		$('body').addClass('cases-filter-open');
		filterBtn.attr('aria-expanded', 'true');
		filterSidebar.attr('aria-hidden', 'false');
	}

	function closeSidebar() {
		state.filterOpen = false;
		layout.removeClass('cases-filter-open');
		$('body').removeClass('cases-filter-open');
		filterBtn.attr('aria-expanded', 'false');
		filterSidebar.attr('aria-hidden', 'true');
	}

	function syncCheckboxesFromPending() {
		industryCheckboxes.each(function () {
			var val = $(this).val();
			$(this).prop('checked', state.pendingIndustries.indexOf(val) !== -1);
		});
		directorCheckboxes.each(function () {
			var val = $(this).val();
			$(this).prop('checked', state.pendingDirectors.indexOf(val) !== -1);
		});
		sortRadios.filter('[value="' + state.sortType + '"]').prop('checked', true);
	}

	function syncPendingFromCheckboxes() {
		state.pendingIndustries = [];
		industryCheckboxes.filter(':checked').each(function () {
			state.pendingIndustries.push($(this).val());
		});
		state.pendingDirectors = [];
		directorCheckboxes.filter(':checked').each(function () {
			state.pendingDirectors.push($(this).val());
		});
		var sortChecked = sortRadios.filter(':checked');
		if (sortChecked.length) {
			state.sortType = sortChecked.val() || 'featured';
		}
	}

	function fetchBrands(append) {
		setLoading(true);
		$.post(thirsty_cases_vars.ajax_url, {
			action: 'filter_brands',
			nonce: thirsty_cases_vars.filter_brands_nonce,
			industries: state.appliedIndustries,
			directors: state.appliedDirectors,
			search: state.search,
			sort_type: state.sortType,
			offset: state.offset
		})
			.done(function (response) {
				if (response.success && response.data) {
					var html = response.data.html || '';
					var hasMore = response.data.has_more;
					var total = response.data.total;
					var shown = response.data.shown !== undefined ? response.data.shown : (state.offset + (html ? $(html).filter('.cell').length : 0));

					if (append) {
						grid.append(html);
					} else {
						grid.html(html);
					}

					updateCount(shown, total);
					showMoreWrap.toggle(!!hasMore);
					state.offset = shown;
				}
			})
			.fail(function () {
				setLoading(false);
			})
			.always(function () {
				setLoading(false);
			});
	}

	function debounce(fn, delay) {
		var timer;
		return function () {
			var args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				fn.apply(null, args);
			}, delay);
		};
	}

	function applyFilters(append) {
		if (typeof append === 'undefined') {
			append = false;
		}
		if (!append) {
			state.offset = 0;
		}
		fetchBrands(append);
	}

	function updateURL() {
		var params = new URLSearchParams(window.location.search);
		var directorVal = state.appliedDirectors.length ? String(state.appliedDirectors[0]) : null;
		var industryVal = state.appliedIndustries.length ? String(state.appliedIndustries[0]) : null;
		if (directorVal) {
			params.set('director', directorVal);
		} else {
			params.delete('director');
		}
		if (industryVal) {
			params.set('industry', industryVal);
		} else {
			params.delete('industry');
		}
		var query = params.toString();
		var newUrl = window.location.pathname + (query ? '?' + query : '');
		window.history.pushState({ casesFilters: true }, '', newUrl);
	}

	function readStateFromURL() {
		var params = new URLSearchParams(window.location.search);
		var directorParam = params.get('director');
		var industryParam = params.get('industry');
		var directorChoices = thirsty_cases_vars.director_choices || {};
		var industryChoices = thirsty_cases_vars.industry_choices || {};
		var appliedDirectors = [];
		var appliedIndustries = [];
		if (directorParam && String(directorParam).trim() !== '') {
			var dirKey = String(directorParam);
			if (Object.prototype.hasOwnProperty.call(directorChoices, dirKey)) {
				appliedDirectors = [dirKey];
			}
		}
		if (industryParam && String(industryParam).trim() !== '') {
			var indKey = String(industryParam);
			if (Object.prototype.hasOwnProperty.call(industryChoices, indKey)) {
				appliedIndustries = [indKey];
			}
		}
		state.appliedDirectors = appliedDirectors;
		state.appliedIndustries = appliedIndustries;
		state.pendingDirectors = appliedDirectors.slice();
		state.pendingIndustries = appliedIndustries.slice();
		syncCheckboxesFromPending();
		state.offset = 0;
		applyFilters(false);
	}

	// Open sidebar
	filterBtn.on('click', function (e) {
		e.stopPropagation();
		if (state.filterOpen) {
			closeSidebar();
		} else {
			syncPendingFromCheckboxes();
			openSidebar();
		}
	});

	// Close sidebar: button
	filterClose.on('click', function () {
		closeSidebar();
	});

	// Close sidebar: click outside (when open)
	$(document).on('click', function (e) {
		if (!state.filterOpen) return;
		if (!filterSidebar[0].contains(e.target) && e.target !== filterBtn[0]) {
			closeSidebar();
		}
	});

	// Checkboxes: update pending only (no API call)
	industryCheckboxes.on('change', function () {
		syncPendingFromCheckboxes();
	});
	directorCheckboxes.on('change', function () {
		syncPendingFromCheckboxes();
	});
	sortRadios.on('change', function () {
		state.sortType = $(this).val() || 'featured';
	});

	// Apply: copy pending to applied, run filter, close sidebar, update URL
	applyBtn.on('click', function () {
		state.appliedIndustries = state.pendingIndustries.slice();
		state.appliedDirectors = state.pendingDirectors.slice();
		closeSidebar();
		updateURL();
		applyFilters(false);
	});

	// Clear all: reset pending and applied, uncheck all, run filter, update URL
	clearBtn.on('click', function () {
		state.pendingIndustries = [];
		state.pendingDirectors = [];
		state.appliedIndustries = [];
		state.appliedDirectors = [];
		state.sortType = 'featured';
		industryCheckboxes.prop('checked', false);
		directorCheckboxes.prop('checked', false);
		sortRadios.filter('[value="featured"]').prop('checked', true);
		closeSidebar();
		updateURL();
		applyFilters(false);
	});

	// Search (300ms debounce) – still immediate apply on type
	searchInput.on('input', debounce(function () {
		state.search = $.trim(searchInput.val() || '');
		applyFilters(false);
	}, 300));

	// Show more
	showMoreBtn.on('click', function () {
		if (isLoading) return;
		applyFilters(true);
	});

	// Initial: sidebar closed, aria-hidden true
	filterSidebar.attr('aria-hidden', 'true');

	// Page load / deep linking: read URL and apply filters if director or industry present
	var initialParams = new URLSearchParams(window.location.search);
	if (initialParams.has('director') || initialParams.has('industry')) {
		readStateFromURL();
	}

	// Browser back/forward: sync state and grid to URL
	window.addEventListener('popstate', function () {
		readStateFromURL();
	});
})(jQuery);
